export const LOADER_TYPES = {
    BOOK_A_MEETING: "BOOK_A_MEETING",
    SETTING_UP_CALL: "SETTING_UP_CALL",
    DEFAULT: "DEFAULT"
};
